<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header :title="$t('MyCommission')" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
                <mt-button slot="right" @click="openPicker">{{ $t('Data') }}</mt-button>
            </mt-header>
        </div>

        <div class="info">
            <div class="item">
                <div class="k">{{ $t('Gross income') }}</div>
                <div class="v">${{ info ? info.available_predeposit : '0.00' }}</div>
            </div>
            <div class="item">
                <div class="k">{{ $t('Direct commission') }}</div>
                <div class="v">${{ info ? info.share_price : '0.00' }}</div>
            </div>
            <div class="item">
                <div class="k">{{ $t('Indirect commission') }}</div>
                <div class="v">${{ info ? info.parent_share_price : '0.00' }}</div>
            </div>
            <div class="item">
                <div class="k">{{ $t('can') + $t('Withdraw') }}</div>
                <div class="v">${{ info ? info.money : '0.00' }}</div>
                <div class="b ds-button" @click="transfer">{{ $t('Withdraw') }}</div>
            </div>
            <div class="tips">{{ $t('Tip: The transfer amount must be greater than 10USDT') }}</div>
        </div>

        <div class="tabs">
            <div class="tab" v-for="(item, index) in tabs" :key="index" :class="{ active: index === activeTab }"
                @click="tabClick(item, index)">{{ $t(item.gc_name) }}</div>
        </div>

        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div class="list" v-if="userList && userList.length && activeTab != 2">
                <div class="item" v-for="(item, index) in userList" :key="index">
                    <div class="sn-date flex">
                        <div class="uname">{{ $t('Username') }}: {{ item.gift ? item.gift.member.member_name : '' }}</div>
                        <div class="date">{{ item.create_time_text }}</div>
                    </div>
                    <div class="sn">sn: {{ item.order_sn }}</div>
                    <div class="rk" v-if="item.gift">{{ item.gift.title + ' ' + item.gift.price + 'USDT' }}</div>
                    <div class="price-type flex">
                        <div class="price">{{ item.num }}USDT</div>
                        <div class="type">
                            {{
                                item.type == 'recovery_gift_parent' ? $t('Direct') :
                                item.type == 'recovery_gift_parent_2' ? $t('Indirect') : item.type
                            }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="list" v-else-if="userList && userList.length && activeTab == 2">
                <div class="item" v-for="(item, index) in userList" :key="index">
                    <div class="sn-date flex">
                        <div class="l">
                            <div class="num">${{ item.total }}</div>
                            <div class="date">{{ item.create_time_text }}</div>
                        </div>
                        <div class="r">{{ item.status_text || $t('succ') }}</div>
                    </div>
                </div>
            </div>
            <empty-record v-else-if="userList && !userList.length"></empty-record>
        </div>

        <mt-datetime-picker ref="picker" type="date" :cancelText="$t('MessageBox.Cancel')"
            :confirmText="$t('MessageBox.Confirm')" v-model="pickerValue" :endDate="endDate_" @confirm="changeTime"
            @touchmove.native.stop.prevent>
        </mt-datetime-picker>
    </div>
</template>
  
<script>
import { createToken } from '../../../api/memberWithdraw'
import { getCommissionList, getCommissionLogList, getCommissionInfo, send_to_predeposit } from '../../../api/memberInviter'
import EmptyRecord from '../../../components/EmptyRecord'
import { Toast, Indicator, MessageBox } from 'mint-ui'
export default {
    name: 'MemberInviterUser',
    components: {
        EmptyRecord
    },
    data() {
        return {
            params: {
                'page': 0,
                'limit': 10,
                // 'date': this.utils.formatDate_(new Date),
                'date': '',
                'type': 'recovery_gift_parent',
            },
            loading: false, // 是否加载更多
            isMore: true, // 是否有更多
            userList: false,
            type: this.$route.query.type ? this.$route.query.type : 0,
            pickerValue: '',
            endDate: '',
            endDate_: new Date(),
            value: '',
            tabs: [
                // {
                //     gc_name: 'commission',
                //     type: '',
                // },
                {
                    gc_name: 'Direct',
                    type: 'recovery_gift_parent',
                },
                {
                    gc_name: 'Indirect',
                    type: 'recovery_gift_parent_2',
                },
                {
                    gc_name: 'Withdraw',
                    type: '',
                },
            ],
            activeTab: this.$route.query.indexe ? this.$route.query.indexe : 0,
            info: null,
            form_token: '',
        }
    },
    created() {
        this.getInfo()
    },

    mounted() {
        window.scrollTo(0, 0);
        this.createToken_()
    },
    methods: {
        createToken_() {
            createToken().then(res => {
                if (res.code == 10000) {
                    this.form_token = res.result.form_token
                }
            })
        },
        transfer() {
            if (this.form_token == '') return
            // this.$router.push({ name: 'MemberWithdrawList' })
            // return
            let that = this
            MessageBox({
                title: that.$t('MessageBox.Tips'),
                message: that.$t('MessageBox.Confirm') + ' ' + that.$t('Withdraw') + '?',
                confirmButtonText: that.$t('MessageBox.Confirm'),
                cancelButtonText: that.$t('MessageBox.Cancel'),
                showCancelButton: true
            }).then(action => {
                if (action == 'confirm') {
                    send_to_predeposit(this.form_token).then(res => {
                        if (res.code == 10000) {
                            Toast(res.message)
                            that.getInfo()
                            that.activeTab = 2
                            that.userList = false
                            that.getUserList(false)
                        } else {
                            Toast(res.message)
                        }
                    }).catch(function (error) {
                        Toast(error.message)
                    })
                }
            }).catch(() => { })
        },
        tabClick(item, index) {
            this.activeTab = index

            if (index == 0) {
                this.params.type = 'recovery_gift_parent'
            } else if (index == 1) {
                this.params.type = 'recovery_gift_parent_2'
            } else {
                this.params.type = 'down_share_price'
            }
            this.userList = false
            this.getUserList(false)
        },
        getInfo(date = '') {
            getCommissionInfo(date).then(res => {
                if (res.code == 10000) {
                    this.info = res.result
                }
            })
        },
        getUserList(ispush) {
            Indicator.open()
            let params = this.params
            if (!ispush) {
                params.page = 1
            }

            if (this.activeTab == 2) {

                getCommissionLogList(params).then(res => {
                    Indicator.close()
                    if (res.code == 10000) {
                        if (ispush && this.userList) {
                            this.userList = this.userList.concat(res.result.data)
                        } else {
                            this.userList = res.result.data
                        }
                        if (res.result.current_page < res.result.last_page) {
                            this.isMore = true
                        } else {
                            this.isMore = false
                        }
                    }
                })

            } else {
                getCommissionList(params).then(res => {
                    Indicator.close()
                    if (res.code == 10000) {
                        if (ispush && this.userList) {
                            this.userList = this.userList.concat(res.result.data)
                        } else {
                            this.userList = res.result.data
                        }
                        if (res.result.current_page < res.result.last_page) {
                            this.isMore = true
                        } else {
                            this.isMore = false
                        }
                    }
                })
            }

        },
        loadMore() {
            this.loading = true
            this.params.page = ++this.params.page
            if (this.isMore) {
                this.loading = false
                this.getUserList(true)
            }
        },
        //打开时间选择器
        openPicker() {// 如果已经选过日期，则再次打开时间选择器时，日期回显（不需要回显的话可以去掉 这个判断）
            if (this.endDate) {
                this.pickerValue = this.endDate
            } else {
                this.pickerValue = new Date()
            }

            this.$refs.picker.open()
        },
        //时间选择器选中
        changeTime(value) {
            console.log(this.utils.formatDate_(value, 'yyyy-MM-dd'));		//自带的value就是选中的时间
            let date = this.utils.formatDate_(value, 'yyyy-MM-dd')
            this.params.date = date
            this.userList = []
            this.getUserList(false)
            this.getInfo(date)

            this.endDate = value
        },
    }
}
</script>
  
<style scoped lang="scss">
.container {
    background: #fff;
    min-height: 100vh;
    padding-bottom: 1px;
}

.info {
    padding: 1.4rem;
    background: #fff;

    .item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;

        .k {
            width: 7rem;
            color: #7F7F7F;
            font-size: 15px;
        }

        .v {
            font-weight: 600;
            font-size: 25px;
            color: #000000;
        }

        .b {
            background: #FB2933;
            border-radius: 10px 10px 10px 10px;
            font-size: 12px;
            color: #FFFFFF;
            padding: 5px 10px;
            margin-left: .6rem;
        }
    }

    .tips {
        font-size: 12px;
        color: #FB2933;
    }
}

.inviter-item {
    display: flex;
    align-items: center;
    padding: .5rem;
    background: #fff;
    border-bottom: 1px solid #e4e4e4;

    .avatar {
        width: 4.5rem;

        img {
            width: 4rem
        }
    }

    .inviter {
        flex: 1;
        font-size: $subFontSize;

        .users {
            font-size: $h3;
            // margin-bottom: 1rem;
            // margin-top: .5rem
        }

        .time {
            color: gray;
            margin-top: .2rem
        }
    }
}

.tabs {
    padding-left: .7rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 .5rem;
    // padding-right: 7.7rem;
    height: 2.5rem;
    background: #fff;

    .tab {
        flex: 1;
        text-align: center;
        font-size: $fontSize;
        color: #333;
        padding: 10px 12px;
    }

    .active {
        color: #fff;
        background: #FB2933;
        border-radius: 10px 10px 10px 10px;
    }
}

.list {
    margin: 20px;
    padding: 0 22px;
    border-radius: 20px;
    border: 1px solid #707070;
    font-size: .6rem;

    .item {
        padding: 20px 0;
        border-bottom: 1px solid #bbbbbb;

        &:last-child {
            border-bottom: none;
        }

        .flex {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .num {
                font-size: .7rem;
                color: #000;
                font-weight: 600;
                margin-bottom: .1rem;
            }

            .r {
                color: #E67F54;
                font-size: .7rem;
                font-weight: 600;
            }
        }

        .uname {
            font-size: .6rem;
        }

        .sn {
            margin: .6rem 0 0;
            font-size: .6rem;
        }

        .date {
            font-size: .57rem;
            color: #8d839c;
        }

        .rk {
            font-size: .8rem;
            margin: 10px 0;
            padding: 10px;
            border-radius: 10px;
        }

        .price-type {
            color: #E67F54;
        }
    }
}
</style>
  